import React, { memo } from 'react';
import { fechaCorta } from 'lib/auditoria';
import { ESTADO_CELDA_LABEL } from 'lib/reporteControl';

// Calendario de cobertura: un cuadrito por día, agrupado por mes (semana de
// lunes a domingo). Colores sutiles de los tokens de estado; el texto de cada
// estado está en la leyenda y en el título de cada día (nunca solo color).
export const CELDA = {
  inspeccionado: 'bg-success/70',
  declarada: 'bg-success/20 ring-1 ring-inset ring-success/70',
  alerta: 'bg-warning',
  falla: 'bg-error',
  sin_operacion: 'bg-muted-foreground/30',
  sin_registro: 'bg-card ring-1 ring-inset ring-foreground/45',
  pendiente: 'bg-card ring-1 ring-inset ring-primary',
  fuera: 'bg-muted/70',
};

export const ORDEN_LEYENDA = ['inspeccionado', 'declarada', 'alerta', 'falla', 'sin_operacion', 'sin_registro'];

const SEMANA = ['L', 'K', 'M', 'J', 'V', 'S', 'D'];

const tituloCelda = (c) => {
  if (c.estado === 'fuera') return `${fechaCorta(c.fecha)}: fuera del período`;
  const quien = c.info?.inspectores?.length ? ` (${c.info.inspectores.join(', ')})` : '';
  return `${fechaCorta(c.fecha)}: ${ESTADO_CELDA_LABEL[c.estado] || c.estado}${quien}`;
};

const Mes = memo(function Mes({ mes, seleccion, onElegir }) {
  return (
    <div className="min-w-0">
      <div className="mb-1 truncate text-xs font-semibold capitalize text-foreground">{mes.titulo}</div>
      <div className="grid grid-cols-7 gap-[3px]" role="group" aria-label={mes.titulo}>
        {SEMANA.map((s, i) => (
          <span key={`s${i}`} className="text-center text-[9px] leading-none text-muted-foreground" aria-hidden="true">{s}</span>
        ))}
        {mes.celdas.map((c, i) => {
          if (!c) return <span key={`v${i}`} aria-hidden="true" />;
          const activa = seleccion === c.fecha;
          const base = `vls-touch-exempt aspect-square w-full rounded-[3px] ${CELDA[c.estado] || CELDA.fuera}`;
          if (c.estado === 'fuera') return <span key={c.fecha} className={base} title={tituloCelda(c)} aria-hidden="true" />;
          return (
            <button key={c.fecha} type="button" onClick={() => onElegir(activa ? null : c.fecha)}
              title={tituloCelda(c)} aria-label={tituloCelda(c)} aria-pressed={activa} data-dia={c.fecha} data-estado={c.estado}
              className={`${base} hover:outline hover:outline-1 hover:outline-offset-1 hover:outline-foreground/50 focus-visible:outline-none
                focus-visible:ring-2 focus-visible:ring-primary ${activa ? 'outline outline-2 outline-offset-1 outline-foreground' : ''}`} />
          );
        })}
      </div>
    </div>
  );
});

export default function Calendario({ meses, seleccion, onElegir }) {
  return (
    <div className="grid grid-cols-3 gap-x-3 gap-y-3 sm:grid-cols-4 lg:grid-cols-6" data-testid="calendario">
      {meses.map((m) => <Mes key={m.clave} mes={m} seleccion={seleccion} onElegir={onElegir} />)}
    </div>
  );
}

export function Leyenda({ conteo }) {
  return (
    <ul className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-muted-foreground" aria-label="Leyenda del calendario">
      {ORDEN_LEYENDA.map((e) => (
        <li key={e} className="inline-flex items-center gap-1.5">
          <span className={`h-3 w-3 shrink-0 rounded-[3px] ${CELDA[e]}`} aria-hidden="true" />
          {ESTADO_CELDA_LABEL[e]}
          {conteo && <span className="tabular-nums text-foreground">{conteo[e] || 0}</span>}
        </li>
      ))}
    </ul>
  );
}
